(function(){
"use strict";
var dati;
try{ dati=JSON.parse(document.getElementById("drDati").textContent); }catch(e){ return; }
if(!dati||!dati.length)return;

var range=document.getElementById("drRange");
var cifra=document.getElementById("drRata");
var budget=document.getElementById("drBudget");
var quanti=document.getElementById("drQuanti");
var griglia=document.getElementById("drGriglia");
var vuoto=document.getElementById("drVuoto");
var bottoni=document.querySelectorAll(".drp .d");
if(!range||!griglia)return;

var mesi=36;
var TAN=0.1228;

function euro(n){return "\u20ac"+Number(n).toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
function euroTondo(n){return "\u20ac"+Math.round(n).toLocaleString("it-IT")}
/* rata da importo */
function rataDa(tot,n){var i=TAN/12;return tot*i/(1-Math.pow(1+i,-n))}
/* importo massimo da rata: formula inversa */
function importoDa(rata,n){var i=TAN/12;return rata*(1-Math.pow(1+i,-n))/i}

var ultimo=null;
function disegna(){
 var r=Number(range.value);
 cifra.textContent=r;

 var p=((r-range.min)/(range.max-range.min))*100;
 range.style.setProperty("--p",p+"%");

 var max=importoDa(r,mesi);
 budget.textContent=euroTondo(max);

 var dentro=dati.filter(function(x){return x.prezzo<=max})
                .sort(function(a,b){return b.prezzo-a.prezzo});
 quanti.textContent=dentro.length;

 var mostra=dentro.slice(0,6);
 var firma=mesi+"|"+mostra.map(function(x){return x.url}).join("|");
 if(firma===ultimo)return;
 ultimo=firma;

 if(!mostra.length){ griglia.innerHTML=""; vuoto.hidden=false; return; }
 vuoto.hidden=true;

 griglia.innerHTML=mostra.map(function(x,i){
  var rr=rataDa(x.prezzo,mesi);
  return '<a class="c" href="'+x.url+'" style="animation-delay:'+(i*0.05)+'s">'+
   '<div class="foto">'+
    (x.badge?'<span class="et-b">'+x.badge+'</span>':'')+
    (x.foto?'<img src="'+x.foto+'" alt="'+x.nome+'" loading="lazy">':'')+
   '</div>'+
   '<h3>'+x.nome+'</h3>'+
   '<div class="r">'+euro(rr)+'<small>/mese</small></div>'+
   '<div class="pz">prezzo pieno '+euroTondo(x.prezzo)+'</div>'+
   '<span class="vai">Scoprilo <svg viewBox="0 0 24 24" width="13" height="13" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'+
  '</a>';
 }).join("");
}

range.addEventListener("input",disegna);
for(var i=0;i<bottoni.length;i++){
 bottoni[i].addEventListener("click",function(){
  for(var j=0;j<bottoni.length;j++)bottoni[j].classList.remove("on");
  this.classList.add("on");
  mesi=Number(this.getAttribute("data-mesi"))||36;
  ultimo=null;
  disegna();
 });
}

disegna();
})();
